export enum FilterUrlTypesEnum {
    MANIPULATE_TO_URL,
    MANIPULATE_ON_URL
}
